import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { Alert } from '../../classes';
import { AlertTypesEnum } from '../../enums';

/**
 * The period which describe how much time
 * the alert will appear on the screen in seconds.
 *
 * Afterward it will be removed automatically.
 */
export const AlertTimeOut = 5;

/***
 * Timing of the effect when alert is closed.
 */
const AnimationTiming = 400;

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  animations: [
    trigger('close', [
      state('closed', style({
        height: 0,
        padding: 0,
        opacity: 0
      })),
      transition('* => closed', [
        animate(AnimationTiming)
      ])
    ])
  ]
})
export class AlertComponent implements OnInit {
  public isAlertOpen: boolean;
  public alertTypes: typeof AlertTypesEnum;

  @Input() public alert: Alert | undefined;

  @Output() public closeAlert: EventEmitter<number>;

  constructor() {
    this.isAlertOpen = true;
    this.alertTypes = AlertTypesEnum;
    this.closeAlert = new EventEmitter();
  }

  ngOnInit(): void {
    if (this.alert && this.alert.isAutoRemovable) {
      /**
       * Close alert automatically after some time.
       */
      this.alert.subscription = of([]).pipe(
        delay(this.alert.timeOut * 1000)
      ).subscribe(() => {
        if (this.alert && this.alert.subscription) {
          this.alert.subscription.unsubscribe();
        }

        this.isAlertOpen = false;

        /**
         * The timeout wait for animation execution.
         */
        setTimeout(() => {
          this.closeAlert.emit(this.alert?.index);
        }, AnimationTiming + 100);
      });
    }
  }

  forceClose(): void {
    this.isAlertOpen = false;

    /**
     * The timeout wait for animation execution.
     */
    setTimeout(() => {
      this.closeAlert.emit(this.alert?.index);
    }, AnimationTiming + 100);
  }
}
